import { render, staticRenderFns } from "./ManageAlerts.vue?vue&type=template&id=61644ab4&scoped=true&"
import script from "./ManageAlerts.vue?vue&type=script&lang=js&"
export * from "./ManageAlerts.vue?vue&type=script&lang=js&"
import style0 from "./ManageAlerts.vue?vue&type=style&index=0&id=61644ab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61644ab4",
  null
  
)

export default component.exports